export interface ValuationsPortfolio {
  closingBalance?: Types | number ;
  closingActual?: Types | number ;
  funds: ValuationsFund[];
}

export interface ValuationsFund {
  fundId: string;
  name: string;
  latestValuation: string;
  price: Types | number;
  units: number;
  closing: Types | number;
  actual: Types | number;
  strategic: number;
  range: number;
}

export interface ValuationsTableFund {
  fundId: string;
  name: string;
  latestValuation: string;
  price: Types | number;
  units: number;
  closing: number;
  actual: Types | number;
  strategic: number;
  range: number;
  selected: boolean;
}

export interface Types {
  mid: number;
  app: number;
  red: number;
}

export interface ValuationsPrices {
  fundId?: string;
  values: ValuationsPrice[];
}

export interface ValuationsPricesRequest {
  account?: string;
  funds?: string;
  from: string;
  to: string;
}

export interface ValuationsPortfolioRequest {
  account: string;
  from: string;
  to: string;
}

export interface ValuationsPrice {
  date: string;
  price?: number;
  value: number;
}

export interface ValuationsCsvRequestPayload {
  account: string;
  priceType: string;
  from: string;
  to: string;
  type?: string;
  exportType?: string;
}

export enum ValuationsTypes {
  PRICE      = 'price',
  UNIT_PRICE = 'unitPrice'
}

export enum PriceTypes {
  SELL = 'red',
  MID  = 'mid',
  BUY  = 'app'
}

export const FULL_PRICE_TYPES = {
  app: 'appPrice',
  red: 'redPrice',
  mid: 'price'
};

export type PriceType = PriceTypes.BUY | PriceTypes.MID | PriceTypes.SELL;

export type ValuationsType = ValuationsTypes.PRICE | ValuationsTypes.UNIT_PRICE;

export interface ValuationsOption {
  value: ValuationsType | PriceType;
  label: string;
}

export const VALUATIONS_OPTIONS: ValuationsOption[] = [
  {
    value: ValuationsTypes.PRICE,
    label: 'Growth of Investments'
  },
  {
    value: ValuationsTypes.UNIT_PRICE,
    label: 'Unit Price'
  }
];

export const PRICE_TYPES: ValuationsOption[] = [
  {
    value: PriceTypes.SELL,
    label: 'Sell Unit Price'
  },
  {
    value: PriceTypes.MID,
    label: 'Mid Unit Price'
  },
  {
    value: PriceTypes.BUY,
    label: 'Buy Unit Price'
  }
];
export enum CsvExportType {
  REGULAR = 'regular',
  HISTORY  = 'history',
  UNIT_PRICE  = 'unit-price'
}

export const CSV_FILENAME = {
  [CsvExportType.REGULAR]: 'ValuationExport.csv',
  [CsvExportType.HISTORY]: 'ValuationHistoryExport.csv',
  [CsvExportType.UNIT_PRICE]: 'UnitPriceHistoryExport.csv'
};

export interface ValuationsFilter {
  type: ValuationsType | PriceType;
  price: PriceType | ValuationsType;
  funds: string[];
  fund: string[];
  from?: string;
  to?: string;
}
